<section>
    <div class="annex-container">
        <h1 class="header-3">Annex III to the Aptoide Connect Certified Developer Distribution Agreement</h1>

        <h4 class="center bottom-margin">Applicable Revenue Share</h4>
        <h4 class="center no-margin-top bottom-margin">Apps distribution through Aptoide App Store and Partner Stores</h4>
        <table>
            <tr>
                <th class="s bold">Entity</th>
                <th class="s bold">Revenue share</th>
            </tr>
            <tr>
                <td><p class="s">Aptoide</p></td>
                <td><p class="s">25%</p></td>
            </tr>
            <tr>
                <td><p class="s">Certified Developer</p></td>
                <td><p class="s">75%</p></td>
            </tr>
        </table>
    </div>
</section>
